import { useFormik } from '@fourthwall/utils/dist/formik';
import { useMemo } from 'react';
import { useRequestRefundMutation } from '../../../hooks/useRequestRefundMutation';
import { validationSchema } from '../consts';
import { CancelRequestType, RefundRequestType } from '../types';
export const useRefundModal = ({ onSuccess }) => {
    const { requestRefundMutation } = useRequestRefundMutation();
    const form = useFormik({
        initialValues: {
            transaction: undefined,
            cancelRequestType: CancelRequestType.Schedule,
            refundRequestType: RefundRequestType.full,
            customAmount: '0',
            cancelSubscription: false,
        },
        validationSchema,
        onSubmit: (values) => {
            if (!values.transaction)
                return;
            const cancelRequestType = values.cancelSubscription ? values.cancelRequestType : undefined;
            if (values.refundRequestType === RefundRequestType.custom) {
                const amount = parseFloat(values.customAmount) * 100;
                return requestRefundMutation.mutate([
                    {
                        amount,
                        chargeId: values.transaction.id,
                        cancelRequestType,
                    },
                ], {
                    onSuccess: () => onSuccess(cancelRequestType),
                });
            }
            if (values.refundRequestType === RefundRequestType.prorated &&
                values.transaction.refundRequest.type === 'Allowed' &&
                values.transaction.refundRequest.options.prorated.type === 'Allowed') {
                const amount = values.transaction.refundRequest.options.prorated.amount;
                return requestRefundMutation.mutate([
                    {
                        amount,
                        chargeId: values.transaction.id,
                        cancelRequestType,
                    },
                ], {
                    onSuccess: () => onSuccess(cancelRequestType),
                });
            }
            if (values.refundRequestType === RefundRequestType.full &&
                values.transaction.refundRequest.type === 'Allowed' &&
                values.transaction.refundRequest.options.full) {
                const amount = values.transaction.refundRequest.options.full.amount;
                return requestRefundMutation.mutate([
                    {
                        amount,
                        chargeId: values.transaction.id,
                        cancelRequestType,
                    },
                ], {
                    onSuccess: () => onSuccess(cancelRequestType),
                });
            }
        },
    });
    const refundAmount = useMemo(() => {
        if (form.values.transaction?.refundRequest.type !== 'Allowed')
            return undefined;
        if (form.values.refundRequestType === RefundRequestType.full &&
            form.values.transaction.refundRequest.options.full)
            return form.values.transaction.refundRequest.options.full.amount / 100;
        if (form.values.refundRequestType === RefundRequestType.prorated &&
            form.values.transaction.refundRequest.options.prorated &&
            form.values.transaction.refundRequest.options.prorated.type === 'Allowed')
            return form.values.transaction.refundRequest.options.prorated.amount / 100;
        if (form.values.refundRequestType === RefundRequestType.custom)
            return parseFloat(form.values.customAmount);
    }, [form]);
    return {
        form,
        refundAmount,
        isLoading: requestRefundMutation.isLoading,
    };
};
